import API from "../api";
import qs from 'qs';


export default class AuthService{
    static login(payload){
       /* axios.post("http://localhost:8000/api/login",payload,{
            headers:{
                'Content-Type': 'application/json',
                'Authorization':'Kizingiti '+sessionStorage.getItem("access")
            }
        })*/
        return API.ax.post('login',payload).catch(e=>console.log(e))
    }



    static refresh(payload){
        return API.ax.post('',payload).catch(e=>console.log(e))
    }

    static logout(){
        return API.ax.post('logout/').catch(e=>console.log(e))
    }


    static appUserLogin(){
        return API.ax.post('generate-uuid/').catch(e=>console.log(e))
    }


      static loadAllCategories(){
        return API.ax.get('serial/list/all/categories').catch(e=>console.log(e))
    }

     static loadAllSubCategoryByCategoryId(id){
        return API.ax.get(`serial/list/subcategories/where/category-id/${id}/`).catch(e=>console.log(e))
    }

   /* static loadAllProducts(id) {
  const queryParams = id ? `?category=${id}` : ''; // Include the 'category' query parameter if 'id' is provided
  return API.ax.get(`/products${queryParams}`)
    .catch(e => console.log(e));
}*/




     static loadAllProducts(category) {

  return API.ax.get(`products/?category=${category}`)
    .catch(e => console.log(e));
}


 static loadProductsBySubCategory(category,subCategory) {

  return API.ax.get(`products/subcategory/?category=${category}&subCategory=${subCategory}`)
    .catch(e => console.log(e));
}

/* static loadProductsByCategoryAndSubCategory(category,subCategory) {
  return API.ax.get(`products/?category=${category}&subCategory=${subCategory}`)
    .catch(e => console.log(e));
}*/

static loadProductsByCategoryAndSubCategory(category, subCategory, page) {
  return API.ax
    .get(`products/?category=${category}&subCategory=${subCategory}&page=${page}`)
    .catch((e) => console.log(e));
}



    static loadProductsByCategoryNameAndSubCategoryName(category, subCategoryName) {
         return API.ax.get(`products/?category=${category}&subCategory=${subCategoryName}`)
    .catch(e => console.log(e));
    }

     static loadProductsByCategoryNameAndSubCategoryNameForPosition(category, subCategoryName, position) {
         return API.ax.get(`/products/?category=${category}&position=${position}&subCategory=${subCategoryName}`)
    .catch(e => console.log(e));
    }



 /*   static loadCartListbyUuid(uuid) {
  return API.ax.get(`carts/?app_user_uuid=${uuid}`)
    .catch(e => console.log(e));
}


   static cartClear(uuid) {
  return API.ax.delete(`cart_item/${uuid}/clear/`)
    .catch(e => console.log(e));
}


   static cartDeleteByProductId(uuid, pid) {
  return API.ax.delete(`cart_item/${uuid}/delete/product/${pid}/`)
    .catch(e => console.log(e));
}*/





       static cartAddItems(data) {
  return API.ax.post(`add_to_cart/`, data)
    .catch(e => console.log(e));
}



       static loadCartListbyUserId(uuid) {
  return API.ax.get(`appuser/${uuid}/cart`)
    .catch(e => console.log(e));
}

/*with oagination*/
  static loadCartListbyUserId1(uuid) {
  return API.ax.get(`cart/${uuid}/`)
    .catch(e => console.log(e));
}

static updateCart(cart_id, data) {
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };

  const formData = qs.stringify(data);

  return API.ax.post(`update-cart/${cart_id}/`, formData, config)
    .catch(e => console.log(e));
}

 /*static updateCart(cart_id, data) {
  return API.ax.post(`update-cart/${cart_id}/`, data)
    .catch(e => console.log(e));
}*/


           static cartItemDeleteByUserId(app_user, cart_item_id) {
  return API.ax.delete(`delete_cart_item/${app_user}/${cart_item_id}/`)
    .catch(e => console.log(e));
}


           static cartClear(app_user) {
  return API.ax.delete(`clear_cart/${app_user}/`)
    .catch(e => console.log(e));
}


     static loadIntro() {
  return API.ax.get(`intro/`)
    .catch(e => console.log(e));
}

}